import React from 'react'
import {PaymentCheckoutCreditTransaction} from '../containers'

export default function PaymentCheckoutCreditScreen() {
  return <PaymentCheckoutCreditTransaction />
}
